import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../shared/Button";
import Input from "../shared/Input";
import Card from "../shared/Card";
import { login } from "../../api/auth";
import { useAuth } from "../../context/AuthContext";
import Swal from "sweetalert2";
import logo from "../../assets/chatea.png";

const LoginForm = () => {
  const navigate = useNavigate();
  const { login: authLogin } = useAuth();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.email) {
      newErrors.email = "El correo electrónico es requerido";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Correo electrónico inválido";
    }
    if (!formData.password) {
      newErrors.password = "La contraseña es requerida";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    try {
      const response = await login(formData);
      if (response.success) {
        authLogin(response.user);

        Swal.fire({
          icon: "success",
          title: "¡Bienvenido!",
          text: "Has iniciado sesión correctamente",
        });

        // Redirigir según el rol del usuario
        if (
          response.user.role === "admin" ||
          response.user.role === "auditor"
        ) {
          navigate("/admin/all-referrals");
        } else {
          navigate("/dashboard");
        }
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "Error al iniciar sesión",
      });
    } finally {
      setLoading(false);
    }
  };

  const navigateToRegister = () => {
    navigate("/register");
  };

  const navigateToRecovery = () => {
    navigate("/recovery");
  };

  return (
    <Card logo={logo} title="Iniciar sesión" className="login-form">
      <form onSubmit={handleSubmit} className="login-form__form">
        <Input
          type="email"
          label="Correo Electrónico"
          name="email"
          value={formData.email}
          onChange={handleChange}
          error={errors.email}
        />
        <Input
          type="password"
          label="Contraseña"
          name="password"
          value={formData.password}
          onChange={handleChange}
          error={errors.password}
        />
        <Button type="submit" variant="primary" disabled={loading} fullWidth>
          {loading ? "Cargando..." : "Iniciar sesión"}
        </Button>
        <p className="login-form__register" onClick={navigateToRegister}>
          ¿No tienes una cuenta? Registrarse
        </p>
        <p className="login-form__register" onClick={navigateToRecovery}>
          ¿Olvidaste tu contraseña?
        </p>
      </form>
    </Card>
  );
};

export default LoginForm;
